const BATCH_SIZE = 500;

const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const normalizeOne = (status) => ({
  status: (status?.status || "").toLowerCase(),
  processedRows: toNumber(status?.processedRows),
  totalRows: toNumber(status?.totalRows),
  errorCount: toNumber(status?.errorCount),
  updatedRows: toNumber(status?.updatedRows),
  importedRows: toNumber(status?.importedRows),
  skippedRows: toNumber(status?.skippedRows),
  failedRows: toNumber(status?.failedRows),
  milestone: Math.floor(toNumber(status?.processedRows) / BATCH_SIZE),
});

export const getImportStatusSnapshot = (statusMap) => ({
  product: normalizeOne(statusMap?.product),
  supplier: normalizeOne(statusMap?.supplier),
});

export const hasMeaningfulImportStatusChange = (prev, next) => {
  if (!prev || !next) return true;

  const keys = ["product", "supplier"];
  for (const key of keys) {
    const prevOne = prev[key];
    const nextOne = next[key];
    if (!prevOne || !nextOne) return true;

    if (prevOne.status !== nextOne.status) return true;
    if (prevOne.errorCount !== nextOne.errorCount) return true;
    if (prevOne.milestone !== nextOne.milestone) return true;
    if (prevOne.failedRows !== nextOne.failedRows) return true;
  }
  return false;
};

export const getNextPollingDelay = (prevDelay, hadMeaningfulChange) => {
  if (hadMeaningfulChange) return 4000;
  if (prevDelay <= 4000) return 8000;
  return 12000;
};

export const isAllImportJobsTerminal = (statusMap) => {
  const terminalStatuses = ["completed", "failed", "cancelled"];
  const statuses = [statusMap?.product?.status, statusMap?.supplier?.status]
    .filter(Boolean)
    .map((value) => String(value).toLowerCase());

  return statuses.length > 0 && statuses.every((status) => terminalStatuses.includes(status));
};
